define([
	"dojo/_base/declare",
	"csi/def",
	"csi/def/Actions",
	"csi/util"
], function(declare, def, Actions, util) {

	return declare(Actions, {
		// Actions: actions to be placed in Actions drop-down menu
		menuActions: null,

		// String: JSON string specifying plugins for toolbar
		plugins: null,

		// String: comma-separated list of plugins to omit from toolbar
		pluginsOmit: null,

		constructor: function(/*XMLNode?*/xn) {
			this.menuActions = util.getDef(xn, "Menu", Actions);
			this.pluginsOmit = util.getProperty(xn, "Omit");
			this.plugins = util.getProperty(xn, "Plugins");
		},

		getAllActions: function() {
			return [].concat(this.getActions() || []).concat(this.getMenuActions() || []);
		},

		getMenuActions: function() {
			return this.menuActions ? this.menuActions.getActions() : null;
		},

		resolve: function(/*LocaleResolver*/lr, /*Class*/rcRoot, /*Node*/nodeRoot) {
			// summary: resolve menu actions
			this.inherited(arguments);

			var menuActions = this.getMenuActions();
			if (menuActions) {
				def.resolveDefs(menuActions, lr, rcRoot, nodeRoot);
			}
		}
	});
});